

import { Component, Vue, Prop } from 'vue-property-decorator';
import { PopupModule } from '~common-store/modules/popup';

@Component({})
export default class PopupHeader extends Vue {
    @Prop({ default: '' }) readonly headerTitle: string | undefined;
    @Prop({ default: '' }) readonly headerSubtitle: string | undefined;
    setPopupInactive() {
        PopupModule.setPopupInactive();
    }
    goBackHistory() {
        PopupModule.goBackHistory();
    }
    goForwardHistory() {
        PopupModule.goForwardHistory();
    }
    get previousPopupExists() {
        return PopupModule.previousPopupExists;
    }
    get nextPopupExists() {
        return PopupModule.nextPopupExists;
    }
}
